import { render, staticRenderFns } from "./AuctionsPagination.vue?vue&type=template&id=3a4ff122&"
import script from "./AuctionsPagination.vue?vue&type=script&lang=js&"
export * from "./AuctionsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4ff122')) {
      api.createRecord('3a4ff122', component.options)
    } else {
      api.reload('3a4ff122', component.options)
    }
    module.hot.accept("./AuctionsPagination.vue?vue&type=template&id=3a4ff122&", function () {
      api.rerender('3a4ff122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/auctions/views/components/AuctionsPagination.vue"
export default component.exports